import {
  Avatar,
  Box
} from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import * as ds from './dataService';
import { ActivitySectionLayout } from 'modules/components/layer32';


export type PersonDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PersonDetailSectionProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.personId ?? '');
  return (
    <Box
      flex='1 1 0'
    >
      <ActivitySectionLayout.FC>
        {
          data.apiFileId
            ? (
              <Box
                maxWidth='100%'
                component='img'
                borderRadius='1rem'
                src={data.url}
              />
            )
            : (
              <Avatar
                sx={{
                  margin: 'auto',
                  height: '10rem',
                  width: '10rem'
                }}
              />
            )

        }
      </ActivitySectionLayout.FC>
    </Box>
  );
};
